/**
 * @module websocket.slice
 */
import { createSlice } from '@reduxjs/toolkit'

const WebSocketSlice = createSlice({
  name: 'websocket',
  initialState: {
    isConnected: false,
    websocketId: undefined,
    connectionStatus: '',
    subscriptions: [],
    flightListUpdated: undefined,
    flightItemUpdated: undefined,
    airlineListUpdated: undefined,
    airlineItemUpdated: undefined,
    airportListUpdated: undefined,
    airportItemUpdated: undefined,
    baggageListUpdated: undefined,
    baggageItemUpdated: undefined,
    bookingListUpdated: undefined,
    bookingItemUpdated: undefined,
    flightAttendantListUpdated: undefined,
    flightAttendantItemUpdated: undefined,
    pilotListUpdated: undefined,
    pilotItemUpdated: undefined,
    simulationListUpdated: undefined,
    simulationItemUpdated: undefined,
    passengerListUpdated: undefined,
    passengerItemUpdated: undefined,
    aircraftListUpdated: undefined,
    aircraftItemUpdated: undefined,
  },
  reducers: {
    setIsConnected: (state, action) => {
      state.isConnected = action.payload
    },
    setWebsocketId: (state, action) => {
      state.websocketId = action.payload
    },
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload
    },
    addSubscription: (state, action) => {
      state.subscriptions.push(action.payload)
    },
    removeSubscription: (state, action) => {
      state.subscriptions = state.subscriptions.filter(
        (subscription) => subscription !== action.payload,
      )
    },
    setFlightListUpdated: (state, action) => {
      state.flightListUpdated = action.payload
    },
    setFlightItemUpdated: (state, action) => {
      state.flightItemUpdated = action.payload
    },
    setAirlineListUpdated: (state, action) => {
      state.airlineListUpdated = action.payload
    },
    setAirlineItemUpdated: (state, action) => {
      state.airlineItemUpdated = action.payload
    },
    setAirportListUpdated: (state, action) => {
      state.airportListUpdated = action.payload
    },
    setAirportItemUpdated: (state, action) => {
      state.airportItemUpdated = action.payload
    },
    setBaggageListUpdated: (state, action) => {
      state.baggageListUpdated = action.payload
    },
    setBaggageItemUpdated: (state, action) => {
      state.baggageItemUpdated = action.payload
    },
    setBookingListUpdated: (state, action) => {
      state.bookingListUpdated = action.payload
    },
    setBookingItemUpdated: (state, action) => {
      state.bookingItemUpdated = action.payload
    },
    setFlightAttendantListUpdated: (state, action) => {
      state.flightAttendantListUpdated = action.payload
    },
    setFlightAttendantItemUpdated: (state, action) => {
      state.flightAttendantItemUpdated = action.payload
    },
    setPilotListUpdated: (state, action) => {
      state.pilotListUpdated = action.payload
    },
    setPilotItemUpdated: (state, action) => {
      state.pilotItemUpdated = action.payload
    },
    setSimulationListUpdated: (state, action) => {
      state.simulationListUpdated = action.payload
    },
    setSimulationItemUpdated: (state, action) => {
      state.simulationItemUpdated = action.payload
    },
    setPassengerListUpdated: (state, action) => {
      state.passengerListUpdated = action.payload
    },
    setPassengerItemUpdated: (state, action) => {
      state.passengerItemUpdated = action.payload
    },
    setAircraftListUpdated: (state, action) => {
      state.aircraftListUpdated = action.payload
    },
    setAircraftItemUpdated: (state, action) => {
      state.aircraftItemUpdated = action.payload
    },
  },
})

export const {
  setIsConnected,
  setWebsocketId,
  setConnectionStatus,
  addSubscription,
  removeSubscription,
  setFlightListUpdated,
  setFlightItemUpdated,
  setAirlineListUpdated,
  setAirlineItemUpdated,
  setAirportListUpdated,
  setAirportItemUpdated,
  setBaggageListUpdated,
  setBaggageItemUpdated,
  setBookingListUpdated,
  setBookingItemUpdated,
  setFlightAttendantListUpdated,
  setFlightAttendantItemUpdated,
  setPilotListUpdated,
  setPilotItemUpdated,
  setSimulationListUpdated,
  setSimulationItemUpdated,
  setPassengerListUpdated,
  setPassengerItemUpdated,
  setAircraftListUpdated,
  setAircraftItemUpdated,
} = WebSocketSlice.actions

export const selectIsConnected = (state) => state?.websocket?.isConnected
export const selectWebsocketId = (state) => state?.websocket?.websocketId
export const selectConnectionStatus = (state) => state?.websocket?.connectionStatus
export const selectSubscriptions = (state) => state?.websocket?.subscriptions
export const selectFlightListUpdated = (state) => state?.websocket?.flightListUpdated
export const selectFlightItemUpdated = (state) => state?.websocket?.flightItemUpdated
export const selectAirlineListUpdated = (state) => state?.websocket?.airlineListUpdated
export const selectAirlineItemUpdated = (state) => state?.websocket?.airlineItemUpdated
export const selectAirportListUpdated = (state) => state?.websocket?.airportListUpdated
export const selectAirportItemUpdated = (state) => state?.websocket?.airportItemUpdated
export const selectBaggageListUpdated = (state) => state?.websocket?.baggageListUpdated
export const selectBaggageItemUpdated = (state) => state?.websocket?.baggageItemUpdated
export const selectBookingListUpdated = (state) => state?.websocket?.bookingListUpdated
export const selectBookingItemUpdated = (state) => state?.websocket?.bookingItemUpdated
export const selectFlightAttendantListUpdated = (state) =>
  state?.websocket?.flightAttendantListUpdated
export const selectFlightAttendantItemUpdated = (state) =>
  state?.websocket?.flightAttendantItemUpdated
export const selectPilotListUpdated = (state) => state?.websocket?.pilotListUpdated
export const selectPilotItemUpdated = (state) => state?.websocket?.pilotItemUpdated
export const selectSimulationListUpdated = (state) => state?.websocket?.simulationListUpdated
export const selectSimulationItemUpdated = (state) => state?.websocket?.simulationItemUpdated
export const selectPassengerListUpdated = (state) => state?.websocket?.passengerListUpdated
export const selectPassengerItemUpdated = (state) => state?.websocket?.passengerItemUpdated
export const selectAircraftListUpdated = (state) => state?.websocket?.aircraftListUpdated
export const selectAircraftItemUpdated = (state) => state?.websocket?.aircraftItemUpdated

export default WebSocketSlice.reducer
